// Core exports
export { PaymentCheckout } from './PaymentCheckout';
export { EventEmitter } from './events/EventEmitter';

// Type exports
export type {
  CheckoutConfig,
  CheckoutState,
  CheckoutEvents,
  CheckoutEventName,
  CheckoutEventListener,
  CustomizationParams,
  Theme,
  ProductLayout,
  CheckoutSuccessData,
  SubmitFormOptions,
  FormSubmittingData,
  FormSubmissionErrorData,
  FormReadyData,
  FormValidationData,
  FormValidationFieldStatus,
  Addon,
  AddonsChangedData,
  CouponAppliedData,
  CouponErrorData,
  PrefillAddress,
  PrefillConfig,
  FieldControl,
  FieldsConfig,
  PrefillableFieldName,
  FieldValueData,
} from './types';

// Class and enum exports
export { PaymentError, PaymentErrorCode } from './types';

// Utility exports
export * from './utils';

// Integration-specific exports
export * from './embed';
